import paymentsConnectTypes from './paymentsConnectTypes'

export const getTriumphPayUrl = () => ({
  type: paymentsConnectTypes.GET_TRIUMPH_PAY_URL
})

export const getTriumphPayUrlSuccess = payload => ({
  type: paymentsConnectTypes.GET_TRIUMPH_PAY_URL_SUCCESS,
  payload
})

export const getTriumphPayUrlFailure = payload => ({
  type: paymentsConnectTypes.GET_TRIUMPH_PAY_URL_FAILURE,
  payload
})

export const generateTriumphPayToken = (payload, callback) => ({
  type: paymentsConnectTypes.GENERATE_TRIUMPH_PAY_TOKEN,
  payload,
  callback
})

export const generateTriumphPayTokenSuccess = payload => ({
  type: paymentsConnectTypes.GENERATE_TRIUMPH_PAY_TOKEN_SUCCESS,
  payload
})

export const generateTriumphPayTokenFailure = payload => ({
  type: paymentsConnectTypes.GENERATE_TRIUMPH_PAY_TOKEN_FAILURE,
  payload
})
